const departments = {
    leader: 'المسؤول',
    leaders: 'مسؤولو القسم',
    led_departments: 'الأقسام التي تديرها',
    edit_leaders: 'إدارة المسؤولين',
    add_leader: 'إضافة',
    remove_leader: 'إزالة',
    no_leaders: 'لم يتم تعيين مسؤولين',
    local: 'إدارة محلية',
    managed_members: 'الأعضاء ضمن نطاق الإدارة',
    leader_scope_hint: 'إدارة عضوية أقسامك والأقسام الفرعية.',
    leader_permission_hint: 'يدير المسؤولون عضوية أقسامهم والأقسام الفرعية دون تغيير أدوار المؤسسة أو هيكل الأقسام.',
    primary_synced: 'يدير Feishu القسم الرئيسي.',
    status_active: 'نشط',
    status_suspended: 'موقوف',
    status_departed: 'غادر',
    status_pending: 'بانتظار التفعيل',
    search: 'بحث',
    previous_page: 'الصفحة السابقة',
    next_page: 'الصفحة التالية',
    directory_title: 'أعضاء المؤسسة',
    member_name: 'العضو',
    search_members: 'البحث بالاسم أو اسم المستخدم',
    include_descendants: 'تضمين الأقسام الفرعية',
    no_members: 'لا يوجد أعضاء مطابقون.',
    all_members: 'جميع الأعضاء',
    all_departments: 'جميع الأقسام',
    edit_member: 'تعديل الأقسام',
    add_child: 'إضافة قسم فرعي',
    expand_department: 'توسيع {{name}}',
    collapse_department: 'طي {{name}}',
    title: 'الأقسام',
    description: 'إدارة الأقسام وعضويات الأعضاء داخل هذه المؤسسة.',
    create: 'إنشاء قسم',
    edit: 'تعديل القسم',
    name: 'اسم القسم',
    parent: 'القسم الرئيسي',
    root: 'بلا قسم رئيسي',
    id: 'معرّف القسم',
    members: 'أقسام الأعضاء',
    member_id: 'معرّف مستخدم العضو',
    primary: 'القسم الأساسي',
    none: 'غير محدد',
    assignments: 'عضويات الأقسام',
    no_assignments: 'لا توجد عضويات أقسام بعد.',
    assignment_hint: 'عيّن أقسامًا محلية وقسمًا أساسيًا اختياريًا. العضويات المُدارة من الدليل للقراءة فقط.',
    empty: 'لا توجد أقسام بعد.',
    readonly: 'يمكنك عرض الأقسام وعضوياتك. تواصل مع مسؤول المؤسسة لإجراء تغييرات.',
    load_error: 'تعذر تحميل البيانات. حاول مجددًا.',
    mutation_error: 'تعذر الحفظ. تحقق من الصلاحيات والعضوية وتسلسل الأقسام.',
    loading: 'جارٍ التحميل…',
    synced: 'يُدار من الدليل',
    choose: 'البحث عن الأقسام',
    organizations_title: 'المؤسسات والأقسام',
    organizations_description: 'اختر مؤسسة لعرض أقسامها أو إدارتها.',
    no_organizations: 'لم تنضم إلى مؤسسة. تواصل مع مسؤول المؤسسة.',
    organization: 'المؤسسة الحالية',
    choose_organization: 'اختر مؤسسة',
    delete_title: 'حذف القسم',
    delete_description: 'هل تريد حذف «{{name}}»؟ انقل الأعضاء والأقسام الفرعية أولًا.',
};
export default Object.freeze(departments);
